import React from 'react';
import { Menu, MenuItem, Paper } from '@mui/material';

const MapMenu = ({ x, y, options, onOptionSelect, open, onClose }) => {
    return (
        <Menu
            open={open}
            onClose={onClose}
            anchorReference="anchorPosition"
            anchorPosition={{ top: y, left: x }}
        >
            {options.map((option, index) => (
                <MenuItem
                    key={index}
                    onClick={() => {
                        onOptionSelect(option);
                        onClose();
                    }}
                >
                    {option.label}
                </MenuItem>
            ))}
        </Menu>
    );
};

export default MapMenu;